var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ol',[_c('li',[_vm._v(" 初始化权限菜单"),_c('el-button',{attrs:{"size":"mini","loading":_vm.initFuncBtn},on:{"click":_vm.initFunc}},[_vm._v("执行")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }